<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.21479 15.3686C11.1994 15.3686 14.4296 12.1521 14.4296 8.18432C14.4296 4.21653 11.1994 1 7.21479 1C3.23017 1 0 4.21653 0 8.18432C0 12.1521 3.23017 15.3686 7.21479 15.3686Z" fill="url(#paint0_radial_0_1029)"/>
<path d="M40.782 47C44.7667 47 47.9968 43.7835 47.9968 39.8157C47.9968 35.8479 44.7667 32.6313 40.782 32.6313C36.7974 32.6313 33.5673 35.8479 33.5673 39.8157C33.5673 43.7835 36.7974 47 40.782 47Z" fill="url(#paint1_radial_0_1029)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.9728 5.25549L12.7463 46.9996H0L20.9728 5.25549Z" fill="url(#paint2_radial_0_1029)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M35.0587 1L26.6259 43.5211C25.4361 45.6613 23.1691 46.9999 20.698 46.9999H12.7437L20.9702 5.25575L21.235 4.72861C22.3831 2.4434 24.729 1 27.2951 1H35.0587Z" fill="url(#paint3_radial_0_1029)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M48 1C48 1 32.1336 32.5672 26.6302 43.5211C26.5793 43.6224 35.0629 1 35.0629 1H48Z" fill="url(#paint4_radial_0_1029)"/>
<defs>
<radialGradient id="paint0_radial_0_1029" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(14.4294 8.18433) rotate(180) scale(16.1236 16.0555)">
<stop stop-color="#6850A1"/>
<stop offset="1" stop-color="#AFAAD4"/>
</radialGradient>
<radialGradient id="paint1_radial_0_1029" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(47.9967 39.8157) rotate(180) scale(14.4294 14.3685)">
<stop stop-color="#6850A1"/>
<stop offset="1" stop-color="#AFAAD4"/>
</radialGradient>
<radialGradient id="paint2_radial_0_1029" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.9728 5.25548) rotate(-168.943) scale(42.714 42.5469)">
<stop stop-color="#6850A1"/>
<stop offset="0.47" stop-color="#7B69AF"/>
<stop offset="1" stop-color="#AFAAD4"/>
</radialGradient>
<radialGradient id="paint3_radial_0_1029" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(35.0587 1) rotate(-168.833) scale(49.4878 49.2945)">
<stop stop-color="#6850A1"/>
<stop offset="1" stop-color="#AFAAD4"/>
</radialGradient>
<radialGradient id="paint4_radial_0_1029" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(48 0.999999) rotate(-153.51) scale(21.9697 21.9139)">
<stop stop-color="#6850A1"/>
<stop offset="1" stop-color="#AFAAD4"/>
</radialGradient>
</defs>
</svg>
